module.exports = {"MEDIUM_DATE":"{value, date, medium}","NUMBERS_LOCALE":"vn-VN"}